const UserAgent = ((): UserAgent => {
  const ua = window.navigator.userAgent.toLowerCase();
  const cuurentUa: UserAgent = {
    isIE: ua.indexOf('trident/7') > -1,
    isEdge: ua.indexOf('edge') > -1,
    isChrome: ua.indexOf('chrome') > -1 && ua.indexOf('edge') === -1,
    isFirefox: ua.indexOf('firefox') > -1,
    isSafari: ua.indexOf('safari') > -1 && ua.indexOf('chrome') === -1,
    isOpera: ua.indexOf('opera') > -1,
    isiPhone: ua.indexOf('iphone') > -1,
    isiPad: ua.indexOf('ipad') > -1,
    isAndroid: ua.indexOf('android') > -1 && ua.indexOf('mobile') > -1,
    isAndroidTablet: ua.indexOf('android') > -1 && ua.indexOf('mobile') === -1,
  };

  return cuurentUa;
})();

export default UserAgent;
